module.exports = __webpack_public_path__ + "static/media/draft.90cb1350.png";